export default "__VITE_ASSET__BVAiGGNr__"